module.exports = __webpack_public_path__ + "img/beneficii.67c04b7e.png";